import { formatTypes } from './models';
import { formatCurrency } from '@sunbit-dev/common/helpers/money';

export const formatByValue = (value: number, formatType: formatTypes) => {
  switch (formatType) {
    case formatTypes.FormatAsCurrency:
      return formatCurrency({ value: value.toString(), showFullDecimalNumber: false });
    case formatTypes.Default:
      return value;
  }
};

export const tooltipFormatter = (params, valueFormatter: (value: number) => string | number) => {
  const _params = Array.isArray(params) ? params : [params];

  const uniqueSeries = new Set<string>(_params.map((item) => item.seriesName));
  const shouldShowTitle = uniqueSeries.size > 1;
  const items = _params
    .filter((item) => item.value)
    .map(
      (item) => `<div style="marginBottom: 10px;display: flex; gap: 10px">
              <b>${shouldShowTitle ? item.seriesName : item.name}</b> ${valueFormatter(
        item.seriesType === 'pie' ? item.data.value : item.value
      )}
              </div>`
    );
  const title = shouldShowTitle ? _params[0].name : '';
  const tooltipElement = `<div style="font-size: 14px; color: #002169; display: flex; gap: 10px; flex-direction: column">
  ${title && `<b>${title}</b>`}
  <div>${items.join('')}</div></div>`;
  const container = (document.createElement('div').innerHTML = tooltipElement);
  return container;
};
